import transform from 'lodash/transform';

function getCompsForType(types, scopedRMI, type, onlyNestedScope) {
    return transform(types.getPotentialViewerTypes(type), (result, value) => {
        const compIds = scopedRMI.getCompIdsFromType(value, onlyNestedScope) || [];
        compIds.forEach((compId) => {
            if (getSdkPublicName(types, scopedRMI, compId) === type) {
                result.push({
                    id: compId,
                    type: value
                });
            }
        });
    }, []);

}

function getSdkConstructorName(types, RMI, compId) {
    const comp = RMI.getComp(compId);
    if (!comp) {
        return null;
    }
    return types.getSdkConstructorName(comp);
}

function getSdkPublicName(types, RMI, compId) {
    const comp = RMI.getComp(compId);
    if (!comp) {
        return null;
    }
    return types.getSdkPublicName(comp);
}


export default {
    getCompsForType,
    getSdkConstructorName,
    getSdkPublicName
};



// WEBPACK FOOTER //
// ./js/modules/privates/wixSelectorUtils.es6